import { z } from 'zod'

export const acceptInviteFormSchema = z
  .object({
    password: z.string().min(1, 'auth:errors.passwordRequired').min(8, 'auth:errors.weakPassword'),
    confirmPassword: z.string().min(1, 'auth:errors.confirmPasswordRequired'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'auth:errors.passwordMismatch',
    path: ['confirmPassword'],
  })

export type AcceptInviteFormValues = z.infer<typeof acceptInviteFormSchema>

export const defaultAcceptInviteValues: AcceptInviteFormValues = {
  password: '',
  confirmPassword: '',
}
